export default "__VITE_PUBLIC_ASSET__4db87c35__"